import { HelloBar, TimerUnit } from '@hg/stylizator/components'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { useCTAAttributes } from 'app/blocks/hooks/useCTA'
import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'

export interface IAttributes extends ICTAAttributes {
  enabled?: boolean
  title: string

  timerType: 'none' | 'date' | 'duration'
  timerDate: string
  timerDuration: number
  timerUnit: TimerUnit
  timerStartDate: string

  pageIds: number[]
}

export const createTimerData = (attributes: IAttributes) => {
  if (attributes.timerType === 'date') {
    return attributes.timerDate
  }

  if (attributes.timerType === 'duration') {
    return {
      duration: attributes.timerDuration,
      unit: attributes.timerUnit,
      startDate: attributes.timerStartDate,
    }
  }

  return undefined
}

const HelloBarBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes
  const { callToAction } = useCTAAttributes(attributes)

  return (
    <HelloBar title={parse(attributes?.title ?? '')} callToAction={callToAction} timer={createTimerData(attributes)} />
  )
}

export default HelloBarBlock
